import type { TCustomerData } from 'shared/types/TCustomerService';

import type { TCreditFormCommonFields, TCreditFormEntityReducer } from 'entities/creditForm';
import { convertDictionaryField } from 'entities/creditForm/lib/mappersToCreditForm/convertDictionaryField';

export const mapCarAndPropertyAvailability = (
  state: TCreditFormEntityReducer,
  data: Partial<TCustomerData>,
): Pick<
  TCreditFormCommonFields,
  | 'carAvailabilityToggleEnabled'
  | 'carAvailability'
  | 'propertyTypeAvailabilityToggleEnabled'
  | 'propertyTypeAvailability'
> => {
  const { dictionaries } = state;

  const propertyTypeAvailability = convertDictionaryField(
    data.propertyTypeAvailability,
    'propertyTypeAvailability',
    dictionaries,
  ) as TCreditFormCommonFields['propertyTypeAvailability'];

  return {
    propertyTypeAvailability,
    propertyTypeAvailabilityToggleEnabled: !!propertyTypeAvailability && propertyTypeAvailability.value !== 'Nothing',
    carAvailability: dictionaries.carAvailabilityTypes.find((item) => item.value === 'No') || null,
    carAvailabilityToggleEnabled: false,
  };
};
